import { render, staticRenderFns } from "./bookcityPage.vue?vue&type=template&id=468ca612&scoped=true"
import script from "./bookcityPage.vue?vue&type=script&lang=js"
export * from "./bookcityPage.vue?vue&type=script&lang=js"
import style0 from "./bookcityPage.vue?vue&type=style&index=0&id=468ca612&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ca612",
  null
  
)

export default component.exports